import React, { useState, useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import AddToCalendar from 'react-add-to-calendar';

const MarketoFormComponent = ({ externalLink, externalLinkTwo, indItem, wistiaVideoId, ctaOverride, formId, formSubmitMessage, formAddToCalendarOnSubmit, formSubmitPdf, filterEmail }) => {
    const marketoScriptId = `mktoForms-${formId}`;
    const [isLoaded, setIsLoaded] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const defaultMessage = <p className="l-defaultMarketoMessage" dangerouslySetInnerHTML={{ __html: "Thank you for your submission" }}></p>
    const submitMessage = <p className="l-defaultMarketoMessage" dangerouslySetInnerHTML={{ __html: formSubmitMessage }}></p>
    const [videoShow, setVideoShow] = useState(false);
    var invalidDomains = [];

    if (!filterEmail) {
        invalidDomains = ["@yahoo.", "@gmail.", "@test.", "@1033edge.", "@11mail.", "@123.", "@123box.", "@123india.", "@123mail."];
    }

    let getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    };

    useEffect(() => {
        if (!document.getElementById(marketoScriptId)) {
            {
                !isLoaded &&
                    loadScript();
            }
        } else {
            setIsLoaded(true);
        }

        if (wistiaVideoId) {
            var scriptOne = document.createElement('script');
            scriptOne.src = '//fast.wistia.com/embed/medias/' + wistiaVideoId + '.jsonp';
            scriptOne.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptOne);
            var scriptTwo = document.createElement('script');
            scriptTwo.src = '//fast.wistia.com/assets/external/E-v1.js';
            scriptTwo.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptTwo);
        }

        if (indItem && indItem.node.slug === 'planful-live-demo') {
            if (process.env.GATSBY_LANG === "de") {
                var _ld_scriptEl = document.createElement('script');
                _ld_scriptEl.src = 'https://cdn.leandata.com/js-snippet/ld-book-v2.js';
                _ld_scriptEl.addEventListener('load', function () {
                    window.LDBookItV2.initialize('00D300000000M8ZEAU', 'DACH Demo', 'LD_BookIt_Log_ID__c');
                    window.LDBookItV2.setFormProvider('marketo');
                });
                document.body.appendChild(_ld_scriptEl);
                console.log("dach leandata");
            }
            else {
                var _ld_scriptEl = document.createElement('script');
                _ld_scriptEl.src = 'https://cdn.leandata.com/js-snippet/ld-book-v2.js';
                _ld_scriptEl.addEventListener('load', function () {
                    window.LDBookItV2.initialize('00D300000000M8ZEAU', 'PFF Demo', 'LD_BookIt_Log_ID__c');
                    window.LDBookItV2.setFormProvider('marketo');
                });
                document.body.appendChild(_ld_scriptEl);
                console.log("live demo leandata");
            }
        }

        if (indItem && indItem.node.slug === 'schedule-a-demo') {
            var _ld_scriptEl = document.createElement('script');
            _ld_scriptEl.src = 'https://cdn.leandata.com/js-snippet/ld-book-v2.js';
            _ld_scriptEl.addEventListener('load', function () {
                window.LDBookItV2.initialize('00D300000000M8ZEAU', 'PFM Demo', 'LD_BookIt_Log_ID__c');
                window.LDBookItV2.setFormProvider('marketo');
            });
            document.body.appendChild(_ld_scriptEl);
            console.log("schedule demo leandata");
        }

    }, []);

    useEffect(() => {
        {
            isLoaded &&
                window.MktoForms2.loadForm(
                    '//marketing.planful.com',
                    "323-LTC-321",
                    formId, function (form) {
                        let cookieTime = getCookie('_ha_mkto_time');
                        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
                        const oneDayAgo = new Date(Date.now() - oneDay);
                        if (cookieTime > oneDayAgo && getCookie('_email')) {
                            form.vals({
                                "Email": getCookie('_email'),
                                "LastName": getCookie('_lastname'),
                                "FirstName": getCookie('_firstname'),
                                "Title": getCookie('_title'),
                                "Company": getCookie('_company')
                            });
                        }

                        form.onSuccess((values) => {
                            setIsSubmitted(true);
                            // Playbook specific to Live Demo page
                            {
                                indItem &&
                                    <>
                                        {indItem.node.slug === 'planful-live-demo' &&
                                            window.LDBookItV2.submit({ formData: values })
                                        }
                                        {indItem.node.slug === 'schedule-a-demo' &&
                                            window.LDBookItV2.submit({ formData: values })
                                        }
                                        {
                                            indItem.node.slug === 'trintech-adra' &&
                                            <>
                                                {
                                                    window.drift.api.collectFormData('#mktoForm_3174', {
                                                        campaignId: 2888235,
                                                    })
                                                }
                                            </>
                                        }
                                        {/* {
                                            indItem.node.slug === 'planful-live-demo' &&
                                            <>
                                                {
                                                    // window.drift('collectFormData', values, {
                                                    //     campaignId: 2319506
                                                    // })
                                                    <>
                                                        {process.env.GATSBY_LANG === "de" ?

                                                            window.drift.api.collectFormData('#mktoForm_3794', {
                                                                campaignId: 2895277,
                                                            })
                                                            :
                                                            window.drift.api.collectFormData('#mktoForm_3619', {
                                                                campaignId: 2884833,
                                                            })
                                                        }
                                                    </>
                                                }
                                            </>
                                        } */}
                                        {/* {
                                            indItem.node.slug === 'schedule-a-demo' &&
                                            <>
                                                {
                                                    window.drift.api.collectFormData('#mktoForm_3620', {
                                                        campaignId: 2884848,
                                                    })
                                                }
                                            </>
                                        } */}
                                        {
                                            indItem.node.slug === 'perform' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2615205
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'how-modern-finance-teams-can-lead-digital-acceleration-in-2022' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620434
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'webinar-how-finance-teams-can-transform-close-and-consolidation' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620494
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'condensed-close-consolidation-with-planful' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620495
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'scaling-scenario-analysis-with-planful' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620503
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'learn-to-scale-cash-flow-management-with-planful' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620506
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'respond-to-risks-with-rolling-forecasts-in-planful' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620511
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'quick-tips-on-scaling-reporting-and-analysis-with-planful' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620513
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'how-finance-leaders-prepare-for-growth-with-dynamic-planning' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620518
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'workforce-planning-with-planful' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2620514
                                                    })
                                                }
                                            </>
                                        }
                                        {
                                            indItem.node.slug === 'removing-the-walls-between-finance-and-marketing' &&
                                            <>
                                                {
                                                    window.drift('collectFormData', values, {
                                                        campaignId: 2669022
                                                    })
                                                }
                                            </>
                                        }
                                    </>
                            }
                            //cookies
                            let current_time = Date.now();

                            let expires = new Date();
                            expires.setTime(expires.getTime() + 5 * 24 * 60 * 60 * 1000);
                            document.cookie = '_ha_mkto_time=' + current_time + '; expires=' + expires.toGMTString();

                            return false;
                        });
                        form.onValidate(function () {
                            var email = form.vals().Email;
                            if (email) {
                                if (!isEmailGood(email)) {
                                    form.submitable(false);
                                    var emailElem = form.getFormElem().find("#Email");
                                    if (process.env.GATSBY_LANG === "de") {
                                        form.showErrorMessage("Muss eine geschäftliche E-Mail-Adresse sein", emailElem);
                                    }
                                    else {
                                        form.showErrorMessage("Must be Business email.", emailElem);
                                    }
                                } else {
                                    form.submitable(true);
                                    setTimeout(() => {
                                        window.Metadata.siteScript.sendData({ email: email })
                                    }, 1000);
                                }
                            }

                            let expires = new Date();
                            expires.setTime(expires.getTime() + 5 * 24 * 60 * 60 * 1000);
                            document.cookie = '_email=' + form.vals().Email + '; expires=' + expires.toGMTString();
                            document.cookie = '_lastname=' + form.vals().LastName + '; expires=' + expires.toGMTString();
                            document.cookie = '_firstname=' + form.vals().FirstName + '; expires=' + expires.toGMTString();
                            document.cookie = '_title=' + form.vals().Title + '; expires=' + expires.toGMTString();
                            document.cookie = '_company=' + form.vals().Company + '; expires=' + expires.toGMTString();

                        });
                    }
                );
        }
    }, [isLoaded, formId]);

    const isEmailGood = (email) => {
        for (var i = 0; i < invalidDomains.length; i++) {
            var domain = invalidDomains[i];
            if (email.indexOf(domain) !== -1) {
                return false;
            }
        }
        return true;
    }

    const loadScript = () => {
        var s = document.createElement('script');
        s.id = marketoScriptId;
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//marketing.planful.com/js/forms2/js/forms2.min.js';
        s.onreadystatechange = function () {
            if (this.readyState === 'complete' || this.readyState === 'loaded') {
                setIsLoaded(true);
            }
        };
        s.onload = () => {
            setIsLoaded(true);
        }
        document.getElementsByTagName('head')[0].appendChild(s);
        let formSelect = `#mktoForm_${formId} .mktoButton`;
        setTimeout(() => {
            if (ctaOverride && document.querySelector('.mktoButton')) {
                document.querySelector(formSelect).innerHTML = ctaOverride;
            }
        }, 4000);
        // Adding Script for Marketo forms
        var formScript = document.createElement('script');
        formScript.innerHTML = function uet_report_conversion() { window.uetq = window.uetq || []; window.uetq.push('event', '', { "event_category": "Marketo Form New Site" }); }
        document.getElementsByTagName('head')[0].appendChild(formScript);

        //metadata
        // var s = document.createElement("script");
        // s.async = true;
        // s.src = "https://cdn.metadata.io/site-script.js";
        // s.onload = function () {
        //     window.Metadata.siteScript.init({});
        // };
        // document.head.appendChild(s);
    };

    const showVideo = (val) => {
        setVideoShow(val);
    }

    let event = null;
    const setEventDetails = (eventTitle, eventDescription, eventLocation, eventStartDate, eventEndDate) => {
        event = {
            title: eventTitle,
            description: eventDescription,
            location: eventLocation,
            startTime: eventStartDate,
            endTime: eventEndDate
        }
    }

    return (
        <div className='l-submitMessage l--centerAlign'>
            {indItem &&
                <>
                    {indItem.node.slug === "planful-live-demo" &&
                        <>
                            {indItem.node.eventsPostFields.marketoSection.marketoFormHeader &&
                                <h3>{indItem.node.eventsPostFields.marketoSection.marketoFormHeader}</h3>
                            }
                            {indItem.node.eventsPostFields.marketoSection.marketoFormTeaser &&
                                <p>{indItem.node.eventsPostFields.marketoSection.marketoFormTeaser}</p>
                            }
                        </>
                    }
                    {indItem.node.slug === "schedule-a-demo" &&
                        <>
                            {indItem.node.eventsPostFields.marketoSection.marketoFormHeader &&
                                <h3>{indItem.node.eventsPostFields.marketoSection.marketoFormHeader}</h3>
                            }
                            {indItem.node.eventsPostFields.marketoSection.marketoFormTeaser &&
                                <p>{indItem.node.eventsPostFields.marketoSection.marketoFormTeaser}</p>
                            }
                        </>
                    }
                </>
            }
            {!isSubmitted &&
                <form id={`mktoForm_${formId}`}></form>
            }
            {isSubmitted &&
                <>
                    {formAddToCalendarOnSubmit === 'yes' &&
                        <>
                            <StaticImage src='../../images/submitIcon.png' alt="" />
                        </>
                    }
                    {formSubmitMessage ? submitMessage : defaultMessage}
                    {formAddToCalendarOnSubmit === 'yes' &&
                        <>
                            {setEventDetails(indItem.node.eventsPostFields.marketoSection.eventTitle, indItem.node.eventsPostFields.marketoSection.eventDescription, indItem.node.eventsPostFields.marketoSection.eventLocation, indItem.node.eventsPostFields.marketoSection.eventStartDate, indItem.node.eventsPostFields.marketoSection.eventEndDate)}
                            <AddToCalendar event={event} />
                        </>
                    }
                    {formSubmitPdf &&
                        <a download href={formSubmitPdf.mediaItemUrl} target="_blank" rel="noreferrer" className="l-button l--flex"><span>Download</span><span><StaticImage src="../../images/icon-rightArrowWhite.svg" alt=""></StaticImage></span></a>
                    }
                    {externalLink &&
                        <a href={externalLink.url} target="_blank" rel="noreferrer" className="l-button l--flex"><span>{externalLink.title}</span><span><StaticImage src="../../images/icon-rightArrowWhite.svg" alt=""></StaticImage></span></a>
                    }
                    {externalLinkTwo &&
                        <a href={externalLinkTwo.url} target="_blank" rel="noreferrer" className="l-button l--flex"><span>{externalLinkTwo.title}</span><span><StaticImage src="../../images/icon-rightArrow.svg" alt=""></StaticImage></span></a>
                    }
                    {wistiaVideoId &&
                        <>
                            <button onClick={() => showVideo(true)} className="l-button l--flex">
                                {process.env.GATSBY_LANG === "de" ?
                                    <span>Video ansehen</span>
                                    :
                                    <span>Watch Video</span>
                                }
                                <span><StaticImage src="../../images/icon-rightArrowWhite.svg" alt=""></StaticImage></span>
                            </button>
                            {videoShow &&
                                <div className="cp-wistiaVideo">
                                    <div className={`wistia_embed wistia_async_${wistiaVideoId}`}>&nbsp;</div>
                                    <button className="cp-wistiaVideo__close" onClick={() => showVideo(false)}>
                                        <StaticImage src="../../images/cross-Icon.svg" alt=""></StaticImage>
                                    </button>
                                </div>
                            }
                        </>
                    }
                </>
            }
        </div>
    );
}

export default MarketoFormComponent;